<div class="EventAgenda" >

    <div *ngIf="eventId">
        <h3 class="heading">Event Agenda</h3>
        <hr class="headinghr">
    </div>
    <div  *ngIf="eventid">
        <h3 class="symposium-heading">Event Agenda</h3>
        <hr class="symposium-headinghr">
    </div>

</div>

<div *ngFor="let schedule of premiereDetails.cinejoySpotlightsSchedule" class="event-agenda-div">
<!-- *************** Everything *************** -->
    <div class="event-details"  >
        
            <div fxLayout="row wrap" class="event-details-div"  > 
                
                <div class="timing">{{schedule.scheduleTimeText | date:"h:mma"}}</div>

                <div class="top-circle"></div>
                
                <div fxFlex.md=40  class="scheduleMainText" *ngIf="schedule.scheduleMainText !== 'GS1' && schedule.scheduleMainText !== 'GS2' && schedule.scheduleMainText !== 'Opening Remarks'">{{schedule.scheduleMainText}} {{schedule.scheduleMainText === 'Screening of' ? premiereDetails.name : '' }}</div>
                <div fxFlex.md=40  class="scheduleMainText" *ngIf="schedule.scheduleMainText === 'GS1' ">Groups join now for Lobby Meetup.</div>
                <div fxFlex.md=40  class="scheduleMainText" *ngIf="schedule.scheduleMainText === 'GS2' ">Group Sharing Lobby Finale</div>
                <div fxFlex.md=40  class="scheduleMainText" *ngIf="schedule.scheduleMainText === 'Opening Remarks' ">Opening Presentation</div>

            </div>
            
            <div class="red-dotted-line">
                    <div   class="scheduleSubText">{{schedule.scheduleSubText}}</div>
            </div>
                
    </div>

<!-- *************** -xxxxx- *************** -->

</div>

<!-- Celebrations event agenda -->
<div *ngFor="let schedule of premiereDetails.schedule" class="event-agenda-div">
    <!-- *************** Everything *************** -->
    <div class="event-details symposiums">

        <div fxLayout="row wrap" class="event-details-div symposiums">

            <div class="timing" style="font-family: 'Lato-Bold' !important;">{{schedule.scheduleTimeText | date:"h:mma"}}</div>

            <div class="top-circle"></div>

            <div fxFlex.md=40 class="scheduleMainText" style="font-family: 'Lato-Bold' !important;">{{schedule.scheduleMainText}}
            </div>
            
        </div>

        <div class="red-dotted-line">

            <div class="scheduleSubText symposiums">{{schedule.scheduleSubText}}</div>

        </div>

    </div>

 </div>   

